import React from "react";
import { FaInstagram, FaFacebook, FaYoutube, FaPaypal } from "react-icons/fa";
import './SocialLinks.css';

const SocialLinks = () => {
  return (
    <div className="grid-container">
        <div className="grid-item">
          <a href="https://www.instagram.com/radiorockandmore" target="_blank" rel="noopener noreferrer">
            <FaInstagram className="icon" /> INSTAGRAM
          </a>
        </div>
        <div className="grid-item">
          <a href="https://www.facebook.com/RadioRockandMore/" target="_blank" rel="noopener noreferrer">
            <FaFacebook className="icon" /> FACEBOOK
          </a>
        </div>
        <div className="grid-item">
          <a href="https://www.youtube.com/radiorockandmore/" target="_blank" rel="noopener noreferrer">
            <FaYoutube className="icon" /> YOUTUBE
          </a>
        </div>
        <div className="grid-item">
          <a href="https://www.paypal.com/donate/?hosted_button_id=8C7HE7P37LW24" target="_blank" rel="noopener noreferrer">
            <FaPaypal className="icon" /> Support/Donar 👈🏼
          </a>
        </div>
    </div>
  );
};

export default SocialLinks;
